"use strict";
exports.__esModule = true;
exports.PARSED_PROGRAMS = void 0;
exports.PARSED_PROGRAMS = {
    SPL_ASSOCIATED_TOKEN_ACCOUNT: "spl-associated-token-account",
    BPF_LOADER: "bpf-loader",
    BPF_UPGRADEABLE_LOADER: "bpf-upgradeable-loader",
    SPL_MEMO: "spl-memo",
    STAKE: "stake",
    SYSTEM: "system",
    SPL_TOKEN: "spl-token",
    VOTE: "vote"
};
//# sourceMappingURL=constants.js.map